var React = require('react');

function Contacts (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Icon/Contact","stroke":"none","strokeWidth":"1","fill":"currentColor","fillRule":"evenodd"},React.createElement("path",{"d":"M10.4193333,8.97835294 C8.78766667,8.97835294 7.45941667,7.63717647 7.45941667,5.98917647 C7.45941667,4.34117647 8.78766667,3 10.4193333,3 C12.0500833,3 13.3774167,4.34117647 13.3774167,5.98917647 C13.3774167,7.63717647 12.0500833,8.97835294 10.4193333,8.97835294 M10.4184167,17.2451765 C6.91308333,17.2451765 5,16.3774118 5,15.9312941 C5,13.6545882 6.68116667,10.448 10.4193333,10.448 C14.1144167,10.448 15.8368333,13.7204706 15.8368333,15.9312941 C15.8368333,16.3774118 13.92375,17.2451765 10.4184167,17.2451765"})));
}

Contacts.defaultProps = {"width":"20px","height":"20px","viewBox":"0 0 20 20","version":"1.1"};

module.exports = Contacts;

Contacts.default = Contacts;
